<template>
  <div class="page">
    <div id="page-header" class="page-header">
      <HeaderButtons
        :pageTitle="'ご注文完了'"
        :isShowCartButton="false"
        :isShowLoginButton="false"
      />
    </div>
    <div id="page-content" class="page-content">
      <article>
        <section>
          <p>
            お客様のお申込みを受付致しました。<br />
            お申込確認メールをお送り致しますので、数時間経ってもメールの確認ができない場合は、
            <a href="mailto:order@bsac.jp">order@bsac.jp</a> までお問い合わせください。<br />
            メールアドレスによっては迷惑メールフォルダにメールが届く可能性がありますので、お手数ですがご確認をお願いします。<br />
          </p>
          <div v-show="payBy === 'A'" class="page-content__creditcard-section">
            <p>クレジットカード決済を選択した方は下記ボタンをクリックしてください。</p>
            <p>
              <button id="nextButton" class="btn btn-danger rounded-pill" @click="redirect">
                クレジットカード決済へ進む
              </button>
            </p>
          </div>
          <div v-show="payBy === 'E'" class="page-content__creditcard-section">
            <p>コンビニ決済を選択した方は下記ボタンをクリックしてください。</p>
            <p>
              <button id="nextButton" class="btn btn-danger rounded-pill" @click="redirect">
                コンビニ決済へ進む
              </button>
            </p>
          </div>
          <div v-show="payBy === 'F'" class="page-content__creditcard-section">
            <p>PayPay決済を選択した方は下記ボタンをクリックしてください。</p>
            <p>
              <button id="nextButton" class="btn btn-danger rounded-pill" @click="redirect">
                PayPay決済へ進む
              </button>
            </p>
          </div>
          <h4 class="page-content__article-section-title--dialog-red">
            【注意事項】※かならずご確認ください。
          </h4>
          <div class="page-content__article-section-body--noindent">
            <ul>
              <li>
                事前振り込みの方は、本メール最後の【振込先口座】をご確認頂き、代金をお振込み下さい。
                <span class="page-content__ul--red">
                  弊社でご入金確認後の商品発送となります。
                </span>
              </li>
              <li>代引き郵便をご選択の方は、到着時に配達員に代金のお支払いをお願い致します。</li>
            </ul>
          </div>
        </section>
      </article>
      <div id="page-footer" class="page-footer">
        <div class="page-footer__next-button-wrapper">
          <div class="page-footer__next-button-inner">
            <router-link to="/" custom v-slot="{ navigate }">
              <button id="nextButton" class="btn btn-secondary rounded-pill" @click="navigate">
                トップページに戻る
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderButtons from 'vues/shopping-order/components/parts/HeaderButtons';

export default {
  components: {
    HeaderButtons,
  },
  computed: {
    /**
     * 選択した支払方法を取得する
     */
    payBy: {
      cache: false,
      get() {
        return this.$store.getters['shoppingOrder/payByInRegisterResponse'];
      },
    },
    /**
     * リダイレクトURLを取得する
     */
    redirectUrl: {
      cache: false,
      get() {
        return this.$store.getters['shoppingOrder/redirectUrlInRegisterResponse'];
      },
    },
    /**
     * 登録処理結果（true/false）を取得する
     */
    result: {
      cache: false,
      get() {
        return this.$store.getters['shoppingOrder/resultInRegisterResponse'];
      },
    },
  },
  created() {
    if (this.result) {
      const partner = this.$store.getters['partner/partner'];
      // 注文情報をクリアする
      this.$store.commit('shoppingOrder/reset');
      // ログイン状態の場合、パートナー情報からお客様情報を再セットする
      if (partner) this.$store.commit('shoppingOrder/setApplicationUsingPartner', partner);
    }
  },
  methods: {
    /**
     * クレジットカード決済画面にリダイレクトする
     */
    redirect: function () {
      location.href = this.redirectUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'stylesheets/page.scss';

.page-content__important-sentense {
  color: red;
  font-weight: bold;
}

.page-content__creditcard-section {
  margin: 1rem 1rem 1rem 1rem;
  padding: 1rem 1rem 1rem 1rem;
  text-align: center;
  border: solid 1px #7d7d7d;
}
</style>
